import { render } from "./BanerWiki.vue?vue&type=template&id=562c3da8&scoped=true"
import script from "./BanerWiki.vue?vue&type=script&lang=js"
export * from "./BanerWiki.vue?vue&type=script&lang=js"

import "./BanerWiki.vue?vue&type=style&index=0&id=562c3da8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562c3da8"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QBtn});
